import { ReactComponent as RegionSidebarSvg } from "../../assets/images/svgs/regionSidebar.svg";

const RegionSidebarIcon = ({ className = "", ...props }) => {
  return (
    <RegionSidebarSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default RegionSidebarIcon;
